// hooks/usePaymentMethods.js
// Payment Methods Hook - Synchronized with Mobile App
import { useQuery } from "@tanstack/react-query";
import { apiService } from "../services/api";

export const usePaymentMethods = () => {
  // Fetch payment methods
  const { data: paymentMethods = [], isLoading, isError, error, refetch } = useQuery({
    queryKey: ['paymentMethods'],
    queryFn: async () => {
      const response = await apiService.getPaymentOptions();
      if (response.status === 'success' && response.data) {
        return response.data;
      }
      return [];
    },
    staleTime: 1000 * 60 * 10,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    gcTime: 1000 * 60 * 30, // 30 minutes
  });

  return {
    // Data
    paymentMethods,
    
    // States
    isLoading,
    isError,
    error,
    
    // Actions
    refetch,
  };
};

export default usePaymentMethods;

